/**
 * Typed-confirmation matching for `ModalConfirm`'s optional `confirmationText`
 * step (FE-15).
 *
 * The task (§9 FE-15, D53) asks for "one intentional act" — typing the exact
 * name of the thing being deleted — rather than a second stacked dialog.
 * Whether that match is case-sensitive is left to FE's call; this module picks
 * **case-sensitive, whitespace-trimmed**:
 *
 * - Case-sensitive because the confirmation target (a tag's name, in FE-15's
 *   case) is itself case-sensitive data — typing it back exactly is the whole
 *   point of the friction, mirroring the well-established "type the resource
 *   name to delete it" pattern (e.g. GitHub repo deletion).
 * - Whitespace-trimmed on the *input* only (never on `expected`) so an
 *   accidental leading/trailing space from autocomplete or a mobile keyboard
 *   doesn't block an otherwise-correct match; the expected value is used
 *   as-is since it comes from application data, not user typing.
 */
export function matchesTypedConfirmation(input: string, expected: string): boolean {
  return input.trim() === expected;
}
